module.exports = __webpack_public_path__ + "6@2x.23095ab9.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/6@2x.png
// module id = LM+x
// module chunks = 0